import { DefaultTheme } from 'styled-components';

import { PADDING, BORDER_RADIUS } from 'constants/sizes';

import { SIZES } from './sizes';
import { COLORS } from './colors';
import * as CONFIGS from './configs';

export const THEME: DefaultTheme = Object.freeze({
  sizes: SIZES,
  colors: COLORS,
  configs: CONFIGS,
  padding: PADDING,
  borderRadius: BORDER_RADIUS,
  scrollBarWidth: '10px',
  transition: {
    default: 'all ease-in-out 0.2s',
  },
});
